function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0) { ; } } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { memo, useCallback, useEffect, useState } from "react";
import cx from "classnames";
import { useDebounceEffect } from "ahooks";
import { useColumnsExtends } from "./columns-extend";
import { Wheel } from "./wheel";
import { withNativeProps } from "../../utils/with-native-props";
import { defaultRenderLabel } from "../picker/picker-utils";
import Loading from "../loading";
import { mergeProps } from "../../utils/mergeProps";
var classPrefix = "tc-picker-view";
var defaultProps = {
  defaultValue: [],
  renderLabel: defaultRenderLabel,
  mouseWheel: false,
  loadingContent: /*#__PURE__*/React.createElement("div", {
    className: "".concat(classPrefix, "-loading-content")
  }, /*#__PURE__*/React.createElement(Loading, null))
};
export var PickerView = /*#__PURE__*/memo(function (p) {
  var props = mergeProps(PickerView.defaultProps, p);
  var value = props.value,
    defaultValue = props.defaultValue,
    loading = props.loading,
    loadingContent = props.loadingContent,
    renderLabel = props.renderLabel,
    mouseWheel = props.mouseWheel;
  var _useState = useState(value === undefined ? defaultValue : value),
    _useState2 = _slicedToArray(_useState, 2),
    innerValue = _useState2[0],
    setInnerValue = _useState2[1];
  // 受控值更新
  useEffect(function () {
    if (props.value === undefined) return;
    if (props.value === innerValue) return;
    setInnerValue(props.value);
  }, [props.value]);
  useEffect(function () {
    if (props.value === innerValue) return;
    var timeout = window.setTimeout(function () {
      if (props.value !== undefined && props.value !== innerValue) {
        setInnerValue(props.value);
      }
    }, 1000);
    return function () {
      window.clearTimeout(timeout);
    };
  }, [props.value, innerValue]);
  var extend = useColumnsExtends(props.columns, innerValue);
  var columns = extend.columns;
  var baseProps = {
    className: cx(classPrefix, props.className),
    style: props.style
  };
  useDebounceEffect(function () {
    var _a;
    if (props.value === innerValue) return;
    (_a = props.onChange) === null || _a === void 0 ? void 0 : _a.call(props, innerValue, extend);
  }, [innerValue], {
    wait: 0,
    leading: false,
    trailing: true
  });
  var handleSelect = useCallback(function (val, index) {
    setInnerValue(function (prev) {
      var next = _toConsumableArray(prev);
      next[index] = val;
      return next;
    });
  }, []);
  return withNativeProps(props, /*#__PURE__*/React.createElement("div", Object.assign({}, baseProps), loading ? loadingContent : /*#__PURE__*/React.createElement(React.Fragment, null, columns.map(function (col, index) {
    return /*#__PURE__*/React.createElement(Wheel, {
      key: index,
      column: col,
      index: index,
      value: innerValue[index],
      onSelect: handleSelect,
      mouseWheel: mouseWheel,
      renderLabel: renderLabel
    });
  }), /*#__PURE__*/React.createElement("div", {
    className: "".concat(classPrefix, "-mask")
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(classPrefix, "-mask-top")
  }), /*#__PURE__*/React.createElement("div", {
    className: "".concat(classPrefix, "-mask-middle")
  }), /*#__PURE__*/React.createElement("div", {
    className: "".concat(classPrefix, "-mask-bottom")
  })))));
});
PickerView.defaultProps = defaultProps;